import React, { useEffect, useState } from 'react';
import ReactDom from 'react-dom';

function CorePortal({ children }: { children: JSX.Element | JSX.Element[] }) {
	const el = document.getElementById('portal') as HTMLElement;

	if (!el) return null;

	return ReactDom.createPortal(children, el);
}

export default CorePortal;

// NEXT의 태그들이 생성되는 곳 밖에 태그를 위치시키고 싶을 때 사용.
// ex) Modal,Toast 등
